// @ts-nocheck
import * as React from "react";

const MapMarker: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="m12 2 .247.004A8 8 0 0 1 20 9.92c0 5.48-7 11.58-7.35 11.84a1 1 0 0 1-1.3 0l-.022-.019C10.805 21.286 4 15.304 4 9.92A8 8 0 0 1 12 2Zm0 1.92a6 6 0 0 0-6 6l.008.274C6.21 13.864 10.37 18.1 12 19.65c1.67-1.59 6-6.03 6-9.73l-.004-.225A6 6 0 0 0 12 3.92ZM12 6l.192.005A3.5 3.5 0 0 1 15.5 9.5l-.005.192A3.5 3.5 0 1 1 12 6Zm0 2a1.5 1.5 0 0 0 0 3l.144-.007A1.5 1.5 0 0 0 13.5 9.5l-.007-.144A1.5 1.5 0 0 0 12 8Z" />
        </svg>
    );
};

export default React.memo(MapMarker);
